import { PACKAGING_LIST_FAIL, PACKAGING_LIST_REQUEST, PACKAGING_LIST_SUCCESS } from "../constats/packaging.constant";

export const packagingListReducer = (state={}, action) => {
    switch (action.type) {
        case PACKAGING_LIST_REQUEST:
            return {
                loading: true
            };
        case PACKAGING_LIST_FAIL:
            return {
                loading: false,
                error: action.payload
            };
        case PACKAGING_LIST_SUCCESS:
            return {
                loading: false,
                data: action.payload
            };
        default:
            return state;
    }
}